import React, { useState } from 'react';
import styles from './addStagesModal.module.scss';
import { Container, Col, Modal, Button } from 'react-bootstrap';
import StageDetailsConfiguration from './stageDetailsConfiguration';
import Review from './review';

const AddStagesModal = (props) => {

    let [step, setStep] = useState(1);
    let [values, setValues] = useState({
        pipeline: props.pipelineID,
        stageName: '',
        stageType: '',
        description: '',
        interview_guidelines_to_candidate: '',
        numReviewer: 1,
        score: '',
        keywords: [],
        keywordToBeAdded: '',
        keywordCount: 0,
        assessment_body: '',
        assessment_exp_date: '',
        quiz_exp_date: '',
        quiz_template: null,
        assessment_reviewers:null,
        reference_check_reviewers:null,
        custom_evaluation_reviewers:null,
        custom_evaluation_description: '',
        one_way_interview_reviewers:null,
        interview_exp_in:'',
        one_way_interview_template: null,

    })
    let [noOfReviewers, setNoOfReviewers] = useState(1);
    let [currentDropValue, setCurrentDropValue] = useState(1);

    function nextPage(value) {
        setStep(value)
    }
    function previousPage(value) {
        setStep(value)
    }

    function setSubmitValues(values) {
        setValues((prevState) => ({
            ...prevState,
            stageName: values.stageName,
            stageType: values.stageType,
            description: values.vacancyDesc,
            interview_guidelines_to_candidate: values.guidelineDescription,
            numReviewer: values.numReviewer,
            score: values.score,
            reviewers: values.reviewers,
            assessment_reviewers: values.assessment_reviewers,
            quiz_template: values.quiz_template,
            keywords: values.keywords,
            keywordCount: values.keywordCount,
            assessment_body: values.assessment_body,
            assessment_exp_date: values.assessment_exp_date,
            quiz_exp_date: values.quiz_exp_date,
            reference_check_reviewers: values.reference_check_reviewers,
            custom_evaluation_reviewers: values.custom_evaluation_reviewers,
            custom_evaluation_description: values.evaluationDescription,
            one_way_interview_reviewers: values.one_way_interview_reviewers,
            interview_exp_in: values.interview_exp_in,
            one_way_interview_template: values.one_way_interview_template,
        }))
    }

    function setNumReviewers(value) {
        setNoOfReviewers(value);
    }

    function setDropValue(value) {
        setCurrentDropValue(value);
    }

    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >

                <Modal.Body className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Add Evaluation Step</h2>
                        <p className={styles.documentLink}  ><a href='https://hiretrace.io/documentation/hiring-pipeline/add-evaluation-steps-to-pipeline' target="_blank">Learn more <i class="fas fa-external-link-alt"></i></a></p>
                    </div>

                    <Col xs={{ span: 6, offset: 3 }} className={styles.stepPosition}>
                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>1</div>
                            <div className={(step === 2) ? styles.stepActive : ''}>2</div>
                        </div>
                    </Col>

                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        <Container className={styles.colWithNoSidePaddings}>
                            <p className={styles.stepSubtopicName}>
                                {
                                    step === 1 ? 'Step Configurations'
                                        : 'Review'
                                }
                            </p>
                            <hr className={styles.subTopicDivider} />
                        </Container>
                    </Col>

                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        <Container className={styles.colWithNoSidePaddings}>
                            {/* Rendering Content Goes Here */}
                            {step === 1 && props.showModal === true && <StageDetailsConfiguration nextPage={nextPage} setSubmitValues={setSubmitValues} values={values} setNumReviewers={setNumReviewers} setDropValue={setDropValue} noOfReviewers={noOfReviewers} currentDropValue={currentDropValue} />}
                            {step === 2 && props.showModal === true && <Review nextPage={nextPage} previousPage={previousPage} values={values} handleClose={props.handleClose} getPipelineValues={props.getPipelineValues} />}
                        </Container>
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    )
}
export default AddStagesModal;